import {RESET_ACTIVE_FEATURE_ITEM, SET_ACTIVE_FEATURE_ITEM} from "../../actions/actionTypes";

const initialState = {
  activeFeatureItems: {} // Structure: { partId: itemIndex }
};

/**
 * Feature grid reducer
 * @param {Object} state - Current state
 * @param {Object} action - Redux action
 * @returns {Object} New state
 */
const featureGridReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ACTIVE_FEATURE_ITEM: {
      const { partId, itemIndex } = action.payload;
      return {
        ...state,
        activeFeatureItems: {
          ...state.activeFeatureItems,
          [partId]: itemIndex
        }
      };
    }

    case RESET_ACTIVE_FEATURE_ITEM: {
      const { partId: resetPartId } = action.payload;

      // If partId is null, reset all
      if (resetPartId === null) {
        return {
          ...state,
          activeFeatureItems: {}
        };
      }

      // Reset specific partId
      const newActiveItems = { ...state.activeFeatureItems };
      delete newActiveItems[resetPartId];

      return {
        ...state,
        activeFeatureItems: newActiveItems
      };
    }

    default:
      return state;
  }
};

export default featureGridReducer;
